import { Alert } from "@circleco/compass/components/Alert";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import { ErrorAlert } from "./ErrorAlert";
import { useUpgradeAcceptance } from "./hooks/useUpgradeAcceptance";
import { UpgradeAcceptanceRecovery } from "./UpgradeAcceptanceRecovery";

interface UpgradeOfferStatusPageProps {
  checkoutPaywallId: number;
  checkoutSessionId: number;
  stepId: number;
}

export const UpgradeOfferStatusPage = ({
  checkoutPaywallId,
  checkoutSessionId,
  stepId,
}: UpgradeOfferStatusPageProps) => {
  const { isAccepting } = useUpgradeAcceptance({
    checkoutPaywallId,
    checkoutSessionId,
    couponMode: "policy",
    hasPreview: false,
    onAcceptanceStateChange: () => {},
    onCouponRefreshRequired: () => {},
    readOnlyProcessing: true,
    stepId,
  });

  return (
    <main className="flex w-full justify-center p-6">
      <div className="w-full max-w-xl space-y-4" aria-live="polite">
        <ErrorAlert />
        <UpgradeAcceptanceRecovery isActive={!isAccepting} />
        {isAccepting && (
          <Alert
            variant="primary"
            icon="circle-info-filled"
            iconColor="info"
            description={
              <Typography variant="body-sm">
                {t("paywall_checkout.offer_page.upgrade.status_checking")}
              </Typography>
            }
          />
        )}
      </div>
    </main>
  );
};
